import { getGenericEndpoint } from './get.api';
import type { GetRegisterResponse } from './types';

export const getRegister = async (lang?: string) => {
	return await getGenericEndpoint<GetRegisterResponse>('register', lang);
};
